import { Component, OnInit } from '@angular/core';

import { MenusService } from '../../../core/api/services/menus.service';
import { BaseSelectSearch } from './base/base-select-search.component';
import { BaseSelectSearchModule } from './base/base-select.search.module';

@Component({
    selector: 'menu-select-search',
    templateUrl: './base/base-select-search-template.html',
    imports: [BaseSelectSearchModule]
})
export class MenuSelectSearchComponent
  extends BaseSelectSearch
  implements OnInit
{
  constructor(protected currentService: MenusService) {
    super();
  }

  initConfig() {
    this.optionValue = 'key';
    this.optionTitle = 'value';
  }

  getItemsApi() {
    this.currentService
      .menusGetTreeMenus({ id: this.id })
      .pipe(this.basePipeOperators())
      .subscribe(this.baseObserver);
  }
}
